<script>
import map from 'lodash/map';
import isArray from 'lodash/isArray';
import { h, defineComponent } from 'vue';

export default defineComponent({
  props: {
    value: { type: [Array, String, Number], default: null },
  },
  render() {
    if (isArray(this.value)) {
      const list = map(this.value, (row) => h('li', row));
      return h('ul', {}, list);
    }
    return this.value || '-';
  },
});
</script>
